import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo } from 'react';
import { useMap, useUpdateEffect } from 'react-use';
import { getNiceTickValues } from 'recharts-scale';
import { isChartInstrument } from '../../utils/groupInstruments';
import { tickCount } from '../instruments/chartInstrument/utils/appearance';
import { calculateChartSeriesMaxValue } from './utils/calculateChartSeriesMaxValue';
import { useComparisonInstrumentsQueryState } from './utils/useComparisonInstrumentsQueryState';
const InstrumentComparisonContext = createContext(undefined);
export function InstrumentComparisonProvider({ children, }) {
    const { left, right } = useComparisonInstrumentsQueryState();
    const [syncOptions, { set }] = useMap({});
    const setSyncOptions = useCallback((type, value) => {
        set(type, Object.assign(Object.assign({}, syncOptions[type]), value));
    }, [set, syncOptions]);
    useUpdateEffect(() => {
        if (!left.isSuccess || !right.isSuccess)
            return;
        const charts = [
            ...left.instruments.filter(isChartInstrument),
            ...right.instruments.filter(isChartInstrument),
        ];
        if (charts.length) {
            const maxValue = calculateChartSeriesMaxValue(charts);
            const ticks = getNiceTickValues([0, maxValue], tickCount, false);
            setSyncOptions('chart', {
                tooltip: true,
                ticks,
            });
        }
    }, [left, right]);
    const contextValue = useMemo(() => ({ syncOptions, setSyncOptions }), [syncOptions, setSyncOptions]);
    return (_jsx(InstrumentComparisonContext.Provider, Object.assign({ value: contextValue }, { children: children })));
}
export function useInstrumentComparison() {
    return useContext(InstrumentComparisonContext);
}
